import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGithub, faLinkedin } from '@fortawesome/free-brands-svg-icons'

import './index.scss'

const Footer = () => {
  return (
    <div className="footer">
      <p className="footer__contact">
        <span className="footer__email">
          <a href="mailto:gyawali_aditya@hotmail.com">gyawali_aditya@hotmail.com</a>
        </span>
        <span className="footer__phone">+358-458982023</span>
      </p>
      <p className="copyright">©adityagyawali 2019</p>
      <ul className="footer__social-icons">
        <li>
          <a href="https://github.com/adityagyawali" target="__blank">
            <FontAwesomeIcon icon={faGithub} />
          </a>
        </li>
        <li>
          <a href=" https://www.linkedin.com/in/aditya-gyawali-99b987a7/" target="__blank">
            <FontAwesomeIcon icon={faLinkedin} />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Footer
